import { render, staticRenderFns } from "./BandejaExtraordinario.vue?vue&type=template&id=064266f6"
import script from "./BandejaExtraordinario.vue?vue&type=script&lang=js"
export * from "./BandejaExtraordinario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports